import storesApis from "../../api/stores";

const state = () => ({
  stores: [],
});

const storesModule = {
  namespaced: true,
  state: state,
  mutations: {
    SET_STORE: (state, payload) => (state.stores = payload),
  },
  actions: {
    async getStores({ commit }, query) {
      const { data } = await storesApis.getStores(query);
      await commit("SET_STORE", data.data);
    }
  }
};

export default storesModule;
